<div class="st-alert-header">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    <div class="st-alert-header-title">{{ title }}</div>
</div>
<div class="st-alert-body">
    {{content}}
</div>
<div class="st-alert-footer">
    <button mat-button
            class="st-alert-button-ok"
            (click)="onOKClick()"
            cdkInitialFocus>
        {{ok}}
    </button>
</div>